import Vue from 'vue'
import Swal from 'sweetalert2'
import addParamsToQuery from '@/utils/addParamsToQuery'
import fetch from '@/utils/fetch'
import SubmissionError from '@/error/SubmissionError'
import store from '@/store/store'

export default class ApiService {
  constructor (route, params) {
    this.route = route
    this.params = params
  }

  setFormData (data) {
    if (!(data instanceof Object)) {
      throw new Error('Data must be type of Object')
    }
    if (Object.keys(data).length === 0) {
      throw new Error('Data shall not be empty')
    }
    this.formData = new FormData()
    Object.keys(data).forEach(entry => {
      this.formData.append(entry, data[entry])
    })
  }

  postSilent (data, contentType = 'application/json') {
    let options = {
      method: 'POST',
      'Content-Type': contentType,
      body: data instanceof FormData ? data : JSON.stringify(data)
    }
    return fetch(this.route, options)
      .then(response => {
        return response
      })
      .catch(err => {
        this.throwMessageError(err)
      })
  }

  post (data) {
    store.state.isProcessing = true
    let options = {
      method: 'POST',
      'Content-Type': 'application/json',
      body: JSON.stringify(data)
    }
    return fetch(this.route, options)
      .then(async response => {
        store.state.isProcessing = false
        if (response.status === 200 || response.status === 201) {
          this.successMessage()
        } else if (response.status === 202) {
          let data = await response.json()
          this.successMessageWithData(data)
        } else if (response.status === 207) {
          let data = await response.json()
          this.warningMessage(data)
        }
        return response
      })
      .catch(err => {
        store.state.isProcessing = false
        return this.throwMessageError(err)
      })
  }

  del (data = {}) {
    store.state.isProcessing = true
    let options = {
      method: 'DELETE',
      'Content-Type': 'application/json',
      body: JSON.stringify(data)
    }
    return fetch(this.route, options)
      .then(async response => {
        store.state.isProcessing = false
        if (response.status === 200 || response.status === 201 || response.status === 204) {
          this.successMessage()
        } else if (response.status === 202) {
          let data = await response.json()
          this.successMessageWithData(data)
        } else if (response.status === 207) {
          let data = await response.json()
          this.warningMessage(data)
        }
        return response
      })
      .catch(err => {
        store.state.isProcessing = false
        return this.throwError(err)
      })
  }

  putSilent (data = '') {
    let options = {
      method: 'PUT',
      'Content-Type': 'application/json',
      body: JSON.stringify(data)
    }
    return fetch(this.route, options)
      .then(response => {
        return response
      })
      .catch(err => {
        return this.throwMessageError(err)
      })
  }

  put (data = '') {
    store.state.isProcessing = true
    // this.setData(data)
    let options = {
      method: 'PUT',
      'Content-Type': 'application/json',
      body: JSON.stringify(data)
    }
    return fetch(this.route, options)
      .then(async (response) => {
        store.state.isProcessing = false
        if (response.status === 200 || response.status === 201) {
          this.successMessage()
        } else if (response.status === 207) {
          let data = await response.json()
          this.warningMessage(data)
        }
        return response
      })
      .catch(err => {
        store.state.isProcessing = false
        return this.throwMessageError(err)
      })
  }

  getResults () {
    let page = addParamsToQuery(this.route, this.params)
    return fetch(page)
      .then(response => {
        return response.json()
      })
      .then(data => {
        if (data['hydra:member']) {
          return {
            totalItems: data['hydra:totalItems'],
            items: data['hydra:member'],
            view: data['hydra:view']
          }
        } else {
          return data
        }
      })
      .catch((e) => {
        this.throwError(e)
      })
  }

  get () {
    let page = addParamsToQuery(this.route, this.params)
    return fetch(page)
      .then(response => {
        return response
      })
      .catch((e) => {
        this.throwError(e)
      })
  }

  downloadFile (fileName) {
    store.state.isProcessing = true
    let query = addParamsToQuery(this.route, this.params)
    return fetch(query)
      .then(res => res.blob())
      .then(blob => {
        var a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.setAttribute('download', fileName)
        a.click()
        store.state.isProcessing = false
      })
      .catch((e) => {
        this.throwError(e)
        store.state.isProcessing = false
      })
  }
  successMessageWithData (data) {
    let text = ''
    for (let i in data) {
      text += data[i] + '\n'
    }
    Swal({
      type: 'success',
      title: text,
      timer: 8000
    })
  }
  successMessage () {
    Swal({ // show notification with success
      type: 'success',
      title: 'Operacja wykonana pomyślnie',
      timer: 2500
    })
  }
  warningMessage (errors) {
    let text = ''
    for (let i in errors) {
      text += errors[i] + '\n'
    }
    Swal({
      type: 'warning',
      title: text,
      timer: 8000
    })
  }

  throwMessageError (e) {
    if (e instanceof SubmissionError) {
      let errors = ''
      for (let key in e.errors) {
        if (key !== '_error') {
          errors += e.errors[key] + '<br />'
        }
      }
      Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        html: errors,
        showConfirmButton: true
      })
      return e.errors
    }
    Swal({
      type: 'warning',
      text: e,
      timer: 2500
    })
  }

  throwError (e) {
    Swal({
      type: 'error',
      title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
      text: e.message,
      showConfirmButton: true,
      timer: 6000
    })
    console.log(e.message)
  }
}
